<div class="terms-conditions overlay" (click)="$event.stopPropagation()">
  <div class="terms-conditions__poup">
    <div class="terms-conditions-wrapper">
      <div class="terms-conditions-content">
        <ng-content></ng-content>
        @if (!isLoading) {
          <div class="site-loader-wrapper">
            <div class="loader"></div>
          </div>
        }
      </div>
      <div class="action-button-wrapper" [ngClass]="{'disabled': !isLoading}">
        <button class="cancel" (click)="onDecline()">Decline</button>
        <button (click)="onAccept()">Accept</button>
      </div>
    </div>
    @if (decline) {
      <div class="cannot-login">
        <p>{{'login_validation' | translate}}</p>
        <div class="action-button-wrapper">
          <button (click)="onOk()">{{'ok' | translate}}</button>
        </div>
      </div>
    }
  </div>
</div>